import { Icon } from '@chakra-ui/react';

export const CreditCards = (props) => (
  <Icon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M9.996 6.6001H5.795C4.804 6.6001 4 7.4041 4 8.3951V19.2061C4 20.1961 4.804 21.0001 5.795 21.0001H12.942C13.933 21.0001 14.737 20.1961 14.737 19.2051V18.4421"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.29505 16.9759L15.8041 18.7299C16.8731 19.0179 17.9721 18.3829 18.2571 17.3139L20.9331 7.26987C21.2151 6.20987 20.5801 5.10987 19.5211 4.82387L13.0121 3.06987C11.9431 2.78187 10.8441 3.41687 10.5591 4.48587L7.88305 14.5299C7.60005 15.5949 8.23105 16.6889 9.29505 16.9759V16.9759Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4 17.5396L15.12 3.63965"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
